import axios from 'axios';

const getBaseURL = () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  // Check if running inside Capacitor native app wrapper
  const isNative = (window.Capacitor && window.Capacitor.isNativePlatform) ||
                   window.location.protocol === 'capacitor:' ||
                   (window.location.protocol === 'http:' && window.location.hostname === 'localhost' && !window.location.port);
  
  if (isNative) {
    return 'https://shubham-computers-backend.onrender.com/api';
  }
  return '/api';
};

const API = axios.create({
  baseURL: getBaseURL(),
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add token from localStorage on init
const token = localStorage.getItem('sc_token');
if (token) {
  API.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}

// Response interceptor for auth errors
API.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      localStorage.removeItem('sc_token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default API;
